


































































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Form } from "element-ui";
// import { openLoading, closeLoading } from "@/utils/loading";

import {
  addMidEvidence,
  updateMidEvidence,
  getMidEvidencePageList,
  defaultMidEvidenceData,
  getListByServiceId,
  getMessageDigest,
  upperChain,
  reUpperChain,
  collect,
  docGenerate,
  chanVerify,
  generateServiceId
} from "@/api/midevidence";
import { getBehaviorJsonInfo } from "@/api/evidict";
import { getBehaviorArrByBusinessId } from "@/api/evibusinessbehavior";
import { getEviBusinessArrByAppId } from "@/api/evibusiness";
import { getCurrentAppArr } from "@/api/eviapp";
import { transStatusTypeDic } from "@/enum/index";
import {
  getCurrectNotUpperchainDic,
  getCurrectNotCollectDic
} from "@/api/eviupperchain";

import { IMidEvidence } from "@/model/midevidence";
import Pagination from "@/components/Pagination/index.vue";
import { syntaxHighlight } from "@/utils";
import store from "@/store";
import { ElForm } from "element-ui/types/form";

@Component({
  name: "midEvidence",
  components: {
    Pagination
  },
  filters: {
    transStatusTypeFilter: (key: number) => {
      return transStatusTypeDic.find((o: any) => o.key === key)?.value;
    }
  }
})
export default class extends Vue {
  private tableKey = 0;
  private midEvidenceData = defaultMidEvidenceData;
  private list: IMidEvidence[] = [];
  private total = 0;
  private currentPage = 1;
  private listLoading = false;
  private pageDisable = false;
  private transStatusTypeDic = transStatusTypeDic;
  private listQuery = {
    pageIndex: 1,
    pageSize: 20,
    search: "",
    appId: "",
    businessId: ""
  };

  private pageQuery = {
    prev: "",
    next: "",
    after: "",
    pageSize: 10,
    search: "",
    appId: "",
    businessId: ""
  };

  private reUpperChainId = "";
  private reCollectId = "";

  private currectServiceId = "";

  private appArr: any[] = [];
  private businessArr: any[] = [];
  private behaviorArr: any[] = [];
  private notUpperchainArr: any[] = [];
  private notCollectArr: any[] = [];

  private midEvidenceDetailList: IMidEvidence[] = [];

  private appSearchArr: any[] = [];
  private businessSearchArr: any[] = [];

  private dialogDetailVisible = false;
  private dialogDoChanVisible = false;
  private dialogReUpperVisible = false;
  private dialogReCollectVisible = false;

  private createRules = {
    appId: [{ required: true, message: "应用名称必填", trigger: "change" }],

    businessId: [
      { required: true, message: "业务名称必填", trigger: "change" }
    ],

    behaviorId: [
      { required: true, message: "业务行为必填", trigger: "change" }
    ],

    subjectId: [{ required: true, message: "主体id必填", trigger: "blur" }],

    behaviorObjectSubjectId: [
      { required: true, message: "行为对象Id必填", trigger: "blur" }
    ],

    rid: [{ required: true, message: "事件Hash必填", trigger: "blur" }],

    serviceId: [{ required: true, message: "业务事件Id必填", trigger: "blur" }],

    requestTime: [
      { required: true, message: "发起请求时间 13毫秒必填", trigger: "blur" }
    ],

    sn: [{ required: true, message: "时间凭证必填", trigger: "blur" }],

    ip: [{ required: true, message: "请求IP必填", trigger: "blur" }],

    ts: [
      { required: true, message: "国家授时返回的时间戳必填", trigger: "blur" }
    ],

    txHash: [{ required: true, message: "交易Hash必填", trigger: "blur" }],

    transStatus: [
      {
        required: true,
        message: "交易状态 0 交易成功，但数据上链失败 1 交易和上链都成功必填",
        trigger: "blur"
      }
    ],

    createTime: [{ required: true, message: "创建时间必填", trigger: "blur" }],

    serviceDataTemp: [
      { required: true, message: "行为内容必填", trigger: "blur" }
    ],

    messageDigest: [
      { required: true, message: "消息摘要必填", trigger: "blur" }
    ],

    // privateKeySign: [
    //   { required: true, message: "私钥对消息摘要签名必填", trigger: "blur" }
    // ],

    beforeCount: [
      { required: true, message: "扣费前计数必填", trigger: "blur" }
    ],

    afterCount: [
      { required: true, message: "扣费后计数必填", trigger: "blur" }
    ],

    description: [{ required: true, message: "事务描述必填", trigger: "blur" }]
  };

  private async doGenerateServiceId(appId: string) {
    await generateServiceId(appId).then(res => {
      this.midEvidenceData.serviceId = res.data;
    });
  }

  private async dochanVerify(serviceId: string) {
    await chanVerify(serviceId).then(res => {
      console.log(res);
      if (res.data.isPass) {
        this.$message({
          message: "链上数据校验通过",
          type: "success",
          duration: 2000
        });
      } else {
        // res.data.errMsgList.forEach((element: any) => {
        //   this.$message({
        //     message: element,
        //     type: "error",
        //     duration: 2000
        //   });
        // });
        this.$notify({
          title: "校验失败明细",
          dangerouslyUseHTMLString: true,
          message: res.data.errMsg,
          type: "error",
          duration: 0,
          showClose: true
        });
      }
    });
  }

  private getDoc(docUrl: string) {
    window.open(docUrl, "_blank");
  }

  private async dodocGenerate(serviceId: string) {
    // openLoading();
    await docGenerate(serviceId).then(() => {
      this.getList("");
      // closeLoading();

      this.$message({
        message: "证据文书已生成",
        type: "success",
        duration: 2000
      });
    });
  }

  private async getNotUpperchain() {
    const { data } = await getCurrectNotUpperchainDic();
    this.notUpperchainArr = data;
  }

  private async getNotCollect() {
    const { data } = await getCurrectNotCollectDic();
    this.notCollectArr = data;
  }

  private doCancelReUpper() {
    this.dialogReUpperVisible = false;
  }

  public async doReUpperChain(eviUpperchainId: string) {
    this.dialogReUpperVisible = false;
    await reUpperChain(eviUpperchainId).then(() => {
      this.getList("");
      this.$message({
        message: "重上链成功",
        type: "success",
        duration: 2000
      });
    });
  }

  // private async doCollect(eviUpperchainId: string) {
  //   this.dialogReCollectVisible = false;
  //   await collect(eviUpperchainId).then(() => {
  //     this.$message({
  //       message: "归集成功",
  //       type: "success",
  //       duration: 2000
  //     });
  //   });
  // }

  private async doUpperChain() {
    (this.$refs.doChanForm as ElForm).validate(async valid => {
      if (valid) {
        this.dialogDoChanVisible = false;
        await upperChain(this.midEvidenceData).then(() => {
          // this.getList();
          this.$message({
            message: "上链成功",
            type: "success",
            duration: 2000
          });

          window.setTimeout(this.getList, 500);
        });
      }
    });
  }

  private async getMessageDigest(encryptInfo: string, behaviorId: string) {
    const { data } = await getMessageDigest(encryptInfo, behaviorId);
    this.midEvidenceData.messageDigest = data.messageDigest;
    this.midEvidenceData.serviceData = data.serviceData;
  }

  private async getBehaviorJson(behaviorId: string) {
    const { data } = await getBehaviorJsonInfo(behaviorId);
    this.midEvidenceData.serviceDataTemp = data;
  }

  private behaviorSelectChange(behaviorId: string) {
    this.getBehaviorJson(behaviorId);
    this.midEvidenceData.serviceData = "";
    this.midEvidenceData.serviceDataTemp = "";
  }

  private appSelectChange(appId: string) {
    this.getEviBusinessArr(appId);
    this.midEvidenceData.businessId = "";
    this.midEvidenceData.behaviorId = "";
    this.midEvidenceData.serviceData = "";
    this.midEvidenceData.serviceDataTemp = "";
  }

  private appSearchSelectChange(appId: string) {
    this.getBusinessSearchArrArr(appId);
    // this.listQuery.businessId = "";
    this.pageQuery.businessId = "";
  }

  private businessSelectChange(businessId: string) {
    this.getBehaviorArr(businessId);
    this.midEvidenceData.behaviorId = "";
    this.midEvidenceData.serviceData = "";
    this.midEvidenceData.serviceDataTemp = "";
  }

  private async getBehaviorArr(businessId: string) {
    const { data } = await getBehaviorArrByBusinessId(businessId);
    this.behaviorArr = data;
  }

  private async getEviBusinessArr(appid: string) {
    const { data } = await getEviBusinessArrByAppId(appid);
    this.businessArr = data;
  }

  private async getBusinessSearchArrArr(appid: string) {
    const { data } = await getEviBusinessArrByAppId(appid);
    this.businessSearchArr = data;
  }

  private async getAppArr() {
    const { data } = await getCurrentAppArr();
    this.appArr = data;
    this.appSearchArr = data;
  }

  private async getDetailList(serviceId: string) {
    const { data } = await getListByServiceId(serviceId);
    this.midEvidenceDetailList = data;

    this.midEvidenceDetailList.forEach((element, index, arr) => {
      element.serviceData = this.jsonFormate(element.serviceData);
    });
  }

  private jsonFormate(json: any) {
    var data = JSON.parse(json);
    return syntaxHighlight(data);
  }

  private openReUpperDialog() {
    this.reUpperChainId = "";
    this.getNotUpperchain();
    this.dialogReUpperVisible = true;
  }

  // private openReCollectDialog() {
  //   this.reCollectId = "";
  //   this.getNotCollect();
  //   this.dialogReCollectVisible = true;
  // }

  private closeDoChanDialog() {
    (this.$refs.doChanForm as ElForm).resetFields();
    this.dialogDoChanVisible = false;
  }

  private openDoChanDialog() {
    this.initData();
    this.dialogDoChanVisible = true;
  }

  private handleFilter() {
    // this.listQuery.pageIndex = 1;
    this.pageQuery.prev = "";
    this.pageQuery.next = "";
    this.getList("");
  }

  created() {
    this.getList("").then(() => {
      this.getAppArr();
    });
  }

  private getDetail(data: IMidEvidence) {
    this.dialogDetailVisible = true;
    // this.eviAppData = data;
    // this.setData(data);
    this.currectServiceId = data.serviceId;
    this.getDetailList(data.serviceId);
  }

  private initData() {
    this.midEvidenceData.id = "";
    this.midEvidenceData.appId = "";
    this.midEvidenceData.businessId = "";
    this.midEvidenceData.behaviorId = "";
    this.midEvidenceData.subjectId = "";
    this.midEvidenceData.behaviorObjectSubjectId = "";
    this.midEvidenceData.rid = "";
    this.midEvidenceData.serviceId = "";
    this.midEvidenceData.requestTime = 0;
    this.midEvidenceData.sn = "";
    this.midEvidenceData.ip = "";
    this.midEvidenceData.ts = 0;
    this.midEvidenceData.txHash = "";
    this.midEvidenceData.transStatus = 0;
    this.midEvidenceData.createTime = 0;
    this.midEvidenceData.serviceData = "";
    this.midEvidenceData.messageDigest = "";
    this.midEvidenceData.privateKeySign = "";
    this.midEvidenceData.beforeCount = 0;
    this.midEvidenceData.afterCount = 0;
    this.midEvidenceData.blockNumber = 0;
    this.midEvidenceData.serviceDataTemp = "";
    this.midEvidenceData.description = "";
    this.midEvidenceData.docUrl = "";
    this.midEvidenceData.hasDoc = false;
  }

  private setData(data: IMidEvidence) {
    this.midEvidenceData.id = data.id;
    this.midEvidenceData.appId = data.appId;
    this.midEvidenceData.businessId = data.businessId;
    this.midEvidenceData.behaviorId = data.behaviorId;
    this.midEvidenceData.subjectId = data.subjectId;
    this.midEvidenceData.behaviorObjectSubjectId = data.behaviorObjectSubjectId;
    this.midEvidenceData.rid = data.rid;
    this.midEvidenceData.serviceId = data.serviceId;
    this.midEvidenceData.requestTime = data.requestTime;
    this.midEvidenceData.sn = data.sn;
    this.midEvidenceData.ip = data.ip;
    this.midEvidenceData.ts = data.ts;
    this.midEvidenceData.txHash = data.txHash;
    this.midEvidenceData.transStatus = data.transStatus;
    this.midEvidenceData.createTime = data.createTime;
    this.midEvidenceData.serviceData = data.serviceData;
    this.midEvidenceData.messageDigest = data.messageDigest;
    this.midEvidenceData.privateKeySign = data.privateKeySign;
    this.midEvidenceData.beforeCount = data.beforeCount;
    this.midEvidenceData.afterCount = data.afterCount;
    this.midEvidenceData.blockNumber = data.blockNumber;
    this.midEvidenceData.serviceDataTemp = data.serviceDataTemp;
    this.midEvidenceData.description = data.description;
    this.midEvidenceData.docUrl = data.docUrl;
    this.midEvidenceData.hasDoc = data.hasDoc;
  }

  private async update() {
    (this.$refs.createForm as Form).validate(async valid => {
      if (valid) {
        await updateMidEvidence(this.midEvidenceData);

        this.$message({
          message: "修改成功",
          type: "success",
          duration: 2000
        });

        this.initData();
        this.dialogDetailVisible = false;
        this.getList("");
      }
    });
  }

  private async create() {
    (this.$refs.createForm as Form).validate(async valid => {
      if (valid) {
        await addMidEvidence(this.midEvidenceData).then(() => {
          this.$message({
            message: "创建成功",
            type: "success",
            duration: 2000
          });

          this.initData();
          this.dialogDetailVisible = false;
          this.getList("");
        });
      }
    });
  }

  // // 获取列表数据
  // private async getList() {
  //   this.listLoading = true;
  //   const { data } = await getMidEvidencePageList(this.listQuery);
  //   // const { data } = await getMidEvidencePageList(this.pageQuery);
  //   this.list = data.list;
  //   this.total = data.total;
  //   // Just to simulate the time of the request
  //   setTimeout(() => {
  //     this.listLoading = false;
  //   }, 0.5 * 1000);
  // }

  // 获取列表数据
  private async getList(pageInfo: any) {
    if (pageInfo.page < this.currentPage) {
      this.currentPage = pageInfo.page;
      this.pageQuery.after = this.pageQuery.prev;
    } else if (pageInfo.page > this.currentPage) {
      this.currentPage = pageInfo.page;
      this.pageQuery.after = this.pageQuery.next;
    } else {
      this.currentPage = 1;
      this.pageQuery.after = "";
    }

    this.listLoading = true;
    const { data } = await getMidEvidencePageList(this.pageQuery);
    // const { data } = await getMidEvidencePageList(this.pageQuery);
    this.list = data.list;
    this.total = data.total;
    this.pageQuery.next = data.after;
    // Just to simulate the time of the request
    setTimeout(() => {
      this.listLoading = false;
    }, 0.5 * 1000);
  }

  private aa() {
    console.log("11");
  }
}
